import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "schedules" }
const _hoisted_2 = {
  key: 0,
  class: "align-center",
  style: {"width":"100px","margin-top":"20vh"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, " Sem Contatos ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_ScheduleDataTable = _resolveComponent("ScheduleDataTable")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showSpinContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_spin, { indicator: _ctx.indicator }, null, 8, ["indicator"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.getSchedules)
            ? (_openBlock(), _createBlock(_component_a_empty, {
                key: 0,
                style: {"margin-top":"20vh"}
              }, {
                description: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_a_tabs, {
                key: 1,
                activeKey: _ctx.activeKey,
                "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
                "default-active-key": "1",
                onChange: _ctx.onChangeTabs,
                type: "card",
                class: "schedules-tabs"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "1",
                    tab: "Todos",
                    class: "full-schedules"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ScheduleDataTable, {
                        favorites: false,
                        onCreateOrEdit: _ctx.createOrEdit,
                        onContactsToEnvelope: _ctx.contactsToEnvelope
                      }, null, 8, ["onCreateOrEdit", "onContactsToEnvelope"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "2",
                    tab: "Favoritos",
                    class: "favorite-schedules"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ScheduleDataTable, {
                        favorites: true,
                        onCreateOrEdit: _ctx.createOrEdit,
                        onContactsToEnvelope: _ctx.contactsToEnvelope
                      }, null, 8, ["onCreateOrEdit", "onContactsToEnvelope"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey", "onChange"]))
        ]))
  ]))
}